import { IUserToken } from '../../@types/model/right/userToken/userToken';
import AuthActions from './actions';
import { createReducer } from '@reduxjs/toolkit';

export interface IAuthState {
    isLoggedIn : boolean;
    session : IUserToken | null;
    token : string;
    isLoggingIn : boolean;
    isLoggingOut : boolean;
}

const initialState = {
    isLoggedIn: false,
    session: null,
    token: '',
    isLoggingIn: false,
    isLoggingOut: false,
};

const authReducer = createReducer<IAuthState>(initialState, (builder) => {
    builder.addCase(AuthActions.setSession, (state, action) => {
        state.session = action.payload;
    });
    builder.addCase(AuthActions.setLoggingIn, (state, action) => {
        state.isLoggingIn = action.payload;
    });
    builder.addCase(AuthActions.setLoggingOut, (state, action) => {
        state.isLoggingOut = action.payload;
    });
    builder.addCase(AuthActions.setToken, (state, action) => {
        state.token = action.payload;
    });
    builder.addCase(AuthActions.logout, () => {
        return initialState;
    });
});

export default authReducer;